module.exports = __webpack_public_path__ + "static/img/products application_cooler1.8b429efc.jpg";